import { render } from "./FormRegister.vue?vue&type=template&id=aa4caa2c&scoped=true"
import script from "./FormRegister.vue?vue&type=script&lang=js"
export * from "./FormRegister.vue?vue&type=script&lang=js"

import "./FormRegister.vue?vue&type=style&index=0&id=aa4caa2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4caa2c"]])

export default __exports__